export default function FullscreenLoader({ message = "Loading..." }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading content"
      className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-slate-950/80 backdrop-blur-sm"
    >
      {/* Spinner Outer Ring */}
      <div className="relative flex items-center justify-center">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-slate-700 border-t-indigo-500" />

        {/* Subtle inner pulse glow */}
        <div className="absolute h-8 w-8 animate-pulse rounded-full bg-indigo-500/20" />
      </div>

      {/* Optional Loading Message */}
      {message && (
        <p className="mt-4 text-sm font-medium tracking-wide text-slate-200">{message}</p>
      )}

      {/* Screen Reader Only text for accessibility */}
      <span className="sr-only">Loading, please wait...</span>
    </div>
  );
}
